import script from "./sf-table-row-collapsible-item.vue?vue&type=script&setup=true&lang=ts&generic=TR%20extends%20GroupedTableRow"
export * from "./sf-table-row-collapsible-item.vue?vue&type=script&setup=true&lang=ts&generic=TR%20extends%20GroupedTableRow"

import "./sf-table-row-collapsible-item.vue?vue&type=style&index=0&id=7110ca8f&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7110ca8f"]])

export default __exports__